import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

const ProgressBar = () => {
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    let timer: NodeJS.Timeout;

    const handleStart = (url: string) => {
      if (url !== router.asPath) {
        setLoading(true)
        setProgress(0)
        
        // Simulate progress
        timer = setInterval(() => {
          setProgress(prev => {
            if (prev >= 90) return 90
            return prev + Math.random() * 30
          })
        }, 200)
      }
    }
    
    const handleComplete = () => {
      setProgress(100)
      setTimeout(() => {
        setLoading(false)
        setProgress(0)
      }, 200)
      if (timer) clearInterval(timer)
    }

    router.events.on('routeChangeStart', handleStart)
    router.events.on('routeChangeComplete', handleComplete)
    router.events.on('routeChangeError', handleComplete)

    return () => {
      router.events.off('routeChangeStart', handleStart)
      router.events.off('routeChangeComplete', handleComplete)
      router.events.off('routeChangeError', handleComplete)
      if (timer) clearInterval(timer)
    }
  }, [router])

  if (!loading) return null

  return (
    <>
      {/* Progress bar */}
      <div className="fixed top-0 left-0 w-full h-[2px] bg-gray-200 z-50">
        <div 
          className="h-full bg-blue-500 transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </>
  )
}

export default ProgressBar;